import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ShellComponent } from './main';

@Component({
  selector: 'app-root',
  imports: [ShellComponent],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  //#region private properties ------------------------------------------------
  private titleService: Title;
  //#endregion

  //#region Constructor & C° --------------------------------------------------
  public constructor(titleService: Title) {
    this.titleService = titleService;
  }

  public ngOnInit(): void {
    this.titleService.setTitle('Der e-coach');
  }
  //#endregion
}
